import { useCallback, useState } from "react";
import useInstrutorStore from "../store/useInstrutorStore";
import useGeneric from "./useGeneric";
import toast from '../utils/toast';

// Pega o autoescola_id do sessionStorage
const getAutoescolaId = () => {
    const id = sessionStorage.getItem("autoescola_id");
    return id ? parseInt(id) : null;
};

export default function useInstrutor() {
    const {
        GenericCreate,
        GenericSearch,
        loading
    } = useGeneric();

    const [horariosLivres, setHorariosLivres] = useState([]);

    const GetInstrutor = async (instrutorId) => {
        const setInstrutor = useInstrutorStore.getState().setInstrutor;

        if (!instrutorId) {
            toast.error("ID do instrutor não informado!");
            return null;
        }

        const body = { id: instrutorId };
        const result = await GenericCreate('instrutor', 'buscarInstrutor', body);

        if (result.success) {
            setInstrutor(result.data[0]);
            return result.data[0];
        } else {
            return result;
        }
    };

    const GetAlunos = async (instrutorId) => {
        const autoescola_id = getAutoescolaId();

        if (!instrutorId || !autoescola_id) {
            toast.error("ID do instrutor ou autoescola não informado!");
            return null;
        }
        //console.log("Buscando alunos para instrutor_id:", instrutorId, "e autoescola_id:", autoescola_id);
        const query = `?instrutor_id=${instrutorId}&autoescola_id=${autoescola_id}`;
        const result = await GenericSearch('instrutor', 'buscarAlunos', query);

        if (result.success) {
            //console.log("Alunos encontrados:", result.data);
            return result.data
        } else {

            return result;
        }
    };

    const SearchAulasInstrutor = async (instrutorId, data) => {
        const autoescola_id = getAutoescolaId();

        if (!instrutorId || !data || !autoescola_id) {
            toast.error("ID do instrutor, data ou autoescola não informado!");
            return null;
        }

        const query = `?instrutor_id=${instrutorId}&data=${data}&autoescola_id=${autoescola_id}`;
        const result = await GenericSearch('instrutor', 'buscarAulasPorInstrutor', query);

        if (result.success) {
            return result.data

        } else {

            return result;
        }
    };

    const getHorariosDisponiveis = async (instrutor_id, data) => {
        const autoescola_id = getAutoescolaId();
        const query = `?instrutor_id=${instrutor_id}&data=${data}&autoescola_id=${autoescola_id}`;
        const result = await GenericSearch('instrutor', 'horariosLivres', query);
        setHorariosLivres(result.data || []);
        return (result.data || []);
    };

    const SearchInstrutorByAluno = useCallback(async (aluno_id, tipo, autoescola_id_vindo) => {
        const autoescola_id_guardado = getAutoescolaId();
        let autoescola_id = autoescola_id_guardado ? autoescola_id_guardado : autoescola_id_vindo;
        if (!aluno_id || !tipo || !autoescola_id) {
            toast.error("Todos os parâmetros são obrigatórios!");
            return null;
        }

        const query = `?aluno_id=${aluno_id}&tipo=${tipo}&autoescola_id=${autoescola_id}`;
        const result = await GenericSearch('instrutor', 'buscarInstrutorPorAluno', query);
        if (result.success) {
            return result.data

        } else {

            return result;
        }
    }, [GenericSearch]);

    const GetAutoescolas = useCallback(async (instrutor_id) => {
        if (!instrutor_id) {
            toast.error("ID do instrutor obrigatório!");
            return null;
        }

        const body = { id: instrutor_id };

        const query = `?instrutor_id=${instrutor_id}`;
        const result = await GenericSearch('instrutor', 'buscarAutoescolas', query);
        //console.log("Resultado da busca de autoescolas:", result.data);

        if (result.success) {
            return result.data

        } else {

            return result;
        }

    }, [GenericSearch]);

    return {
        GetInstrutor,
        GetAlunos,
        SearchAulasInstrutor,
        SearchInstrutorByAluno,
        GetAutoescolas,
        horariosLivres,
        getHorariosDisponiveis,
        loading
    };
}
